import Stanowiska from './Stanowiska';
export default Stanowiska;